import React from 'react';
import config from '../../../utils/constants/config';
import Elmahio from 'elmah.io.javascript/dist/elmahio';
import GENERAL_FUNCTIONS from '../../../utils/functions/functions';
import RefreshPage from '../refreshPage/refreshPage';
import store from '../../../store/store';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
        this.log = new Elmahio({
            application: `Claims.WEB.ReactJS.${config.ENV_NAME}`,
        });
    }

    callToApi = async props => {
        const state = store.getState();
        const token = state.applicationUser?.accessToken;

        await fetch(
            GENERAL_FUNCTIONS.getBaseURL() + 'api/Services/elmah/message',
            {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(props),
            },
        );
    };

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    async componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        var msg = this.log.message(error); // Get a prefilled message
        msg.title = error.message;
        msg.queryString = {};
        msg.severity = 'Error';
        msg.type = error.name;
        msg.detail = error.stack;
        await this.callToApi(msg);
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return <RefreshPage />;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
